import { Controller, useFormContext } from 'react-hook-form';
import { WebhookUpdateAppModel } from '@api';
import { LabeledTextField, MaterialIcon } from '@components';
import { Box, Tooltip } from '@mui/material';

export default function CustomValidationErrorMessageField() {
  const { control } = useFormContext<WebhookUpdateAppModel>();

  return (
    <Controller
      control={control}
      name="custom_validation_error_message"
      render={({ field, fieldState: { invalid, error } }) => (
        <LabeledTextField
          optional
          multiline
          error={invalid}
          inputProps={field}
          helperText={error?.message}
          placeholder="This message will be displayed to the user when the webhook validation fails."
          label="Custom Validation Error Message"
          subLabel={
            <Tooltip title="Insert custom error messages for end users requesting access" placement="top" arrow>
              <Box>
                <MaterialIcon symbol="help_outline" block size="small" />
              </Box>
            </Tooltip>
          }
        />
      )}
    />
  );
}
